import {
  Table,
  OverlayTrigger,
  Tooltip,
  Modal,
  Row,
  Button,
  Form,
} from "react-bootstrap";

import { ChangeEvent, useEffect, useRef, useState } from "react";

import Snackbar from "../../../../common/Snackbar";
import {
  addLineItems,
  deleteLineItems,
  getLineItemListByCaseID,
  updateAutomatedLineItems,
  updateCustomLineItems,
} from "../../../../services/ManageInvoiceAPI";
import {
  fetchUerListByCase,
  fetchUerListByTenantID,
} from "../../../../services/BillingConfigApi";
import {
  INVOICE_STATUS,
  PICKLIST_GROUP_NAME,
} from "../../../../common/Constant";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/Store";
import { fetchPickListByGroupName } from "../../../../services/CaseInformationApi";
import {
  formatAppointmentDateTime,
  formatDateTime,
  formattedDate,
} from "../../../../utils/dateUtils";
import TableSingleSelectDropdown from "../../../../common/TableSingleSelectDropdown";
import InvoiceCommentsDrawer from "./InvoiceCommentsDrawer";
import ViewComments from "./ViewComments";
import FloatingLabelDatepicker from "../../../../common/DatePicker";
import NormalDatePicker from "../../../../common/NormalDatePicker";
import { getAppointmentListByCase } from "../../../../services/ScheduleAppointmentApi";
import CurrencyRateInput from "../../../../common/CurrencyRateInput";
import {
  getInvoiceCaseNotes,
  getStandardChargeNotesDetails,
} from "../../../../services/InvoiceAPI";
import FloatingTableModal from "../../../../common/FloatingTableModal";
import { INVOICE_NOTES_INFO_HEADER } from "../actions/constants";

interface DataTableProps {
  headers: {
    key: string;
    label: string;
    sortable?: boolean;
    items?: any;
    style?: any;
    isNumeric?: boolean;
  }[];

  caseInfoID?: any;
  searchQuery?: any;
  onAddSuccess?: () => void;
  invoiceStatus: string;
}

interface UserOptiopn {
  userId?: number;
  usfUlNameRole?: string;
}

const rateTypeOptions = [
  {
    value: "Fixed",
    label: "Fixed",
  },
  {
    value: "PER_PAGE",
    label: "Per Page",
  },
  {
    value: "PER_LINE",
    label: "Per Line",
  },
];

const currencyOptions = [
  {
    value: "USD",
    label: "USD",
  },
  {
    value: "INR",
    label: "INR",
  },
];

const InvoiceLineItemEditTableData: React.FC<DataTableProps> = ({
  headers,
  caseInfoID,
  searchQuery,
  onAddSuccess,
  invoiceStatus,
}) => {
  const userID = useSelector((state: RootState) => state.auth.userid);

  const inputRef = useRef<HTMLInputElement>(null);
  const dropdownRef = useRef<HTMLUListElement | null>(null);
  const [dropdownStyle, setDropdownStyle] = useState<any>(null);

  const [lineItemData, setLineItemData] = useState<any[]>([]);
  const [userData, setUserData] = useState<UserOptiopn[]>([]);
  const [userSearchQuery, setUserSearchQuery] = useState<string>("");
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [appointmentOptions, setAppointmentOptions] = useState<any[]>([]);
  const [selectedAppointment, setSelectedAppointment] = useState<any>(null);
  const [selectedCurrency, setSelectedCurrency] = useState<any>("USD");
  const [currencySymbol, setCurrencySymbol] = useState("");
  const [rateType, setRateType] = useState<any>(null);
  const [totalPages, setTotalPages] = useState<any>("");
  const [totalLines, setTotalLines] = useState<any>("");
  const [rate, setRate] = useState<any>("");
  const [amount, setAmount] = useState<any>("");
  const [isActive, setIsActive] = useState<any>(false);
  const [showAddRow, setShowAddRow] = useState(false);
  const [editingRowId, setEditingRowId] = useState<number | null>(null);
  const [lineItemType, setLineItemType] = useState("");
  const [activeState, setActiveState] = useState(true);
  const [deletingRowId, setDeletingRowId] = useState<number | null>(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [modalDetails, setModalDetails] = useState<any[]>([]);
  const [modalNotesData, setModalNotesData] = useState<any[]>([]);
  const [modalTitle, setModalTitle] = useState<string>("");
  const [modalPos, setModalPos] = useState<{
    top: number;
    left?: number;
    right?: number;
  } | null>(null);

  const [effectiveDateFrom, setEffectiveDateFrom] = useState<Date | null>(
    new Date(),
  );

  const [openComments, setOpenModal] = useState(false);

  const getLineItemsData = async () => {
    const searchPayload = {
      caseInfoId: caseInfoID,
      searchText: searchQuery,
    };

    const response = await getLineItemListByCaseID(searchPayload);

    const mappedData = response.map((item: any) => ({
      ...item,
      billingRuleRate:
        item.currencySymbol === "X"
          ? ""
          : `${item.currencySymbol} ${Number(item.billingRuleRate ?? 0).toFixed(2)}`,
      totalAmount:
        item.currencySymbol === "X"
          ? ""
          : `${item.currencySymbol} ${Number(item.totalAmount ?? 0).toFixed(2)}`,
      generatedBy: `${formatAppointmentDateTime(item.effectiveChargeDate)} | ${item.createdByName}`,
      rateType:
        item.billingRuleRateType == "PER_LINE"
          ? "Per Line"
          : item.billingRuleRateType == "PER_PAGE"
            ? "Per Page"
            : item.billingRuleRateType,
    }));

    setLineItemData(mappedData);
  };

  console.log(lineItemData, "GGGGGG");

  const params = {
    examType: {
      groupName: PICKLIST_GROUP_NAME.Appointment_Type,
      triggerById: userID,
    },
  };

  const getAppointmentList = async () => {
    const response = await getAppointmentListByCase(caseInfoID);
    setAppointmentOptions(response);
  };

  useEffect(() => {
    if (!caseInfoID) return;

    getLineItemsData();
    getAppointmentList();
  }, [caseInfoID, searchQuery]);

  const handleSearchUser = async (e: ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value;
    if (query.startsWith(" ")) return;

    setUserSearchQuery(query);

    const trimmedQuery = query.trim();
    if (trimmedQuery.length < 3) {
      setUserData([]);
      return;
    }

    if (inputRef.current) {
      const rect = inputRef.current.getBoundingClientRect();

      setDropdownStyle({
        position: "fixed",
        top: rect.bottom + 4,
        left: rect.left,
        width: rect.width,
        zIndex: 9999,
        maxHeight: "180px",
        overflowY: "auto",
        background: "#fff",
        border: "1px solid #dee2e6",
        borderRadius: "4px",
      });
    }

    const payload = {
      caseInfoId: caseInfoID,
      searchString: trimmedQuery,
    };

    const response: any = await fetchUerListByCase(payload);
    setUserData(response?.result ?? []);
  };

  useEffect(() => {
    const handleScroll = (event: Event) => {
      // If scroll happened inside dropdown → ignore
      if (
        dropdownRef.current &&
        dropdownRef.current.contains(event.target as Node)
      ) {
        return;
      }

      // Otherwise close dropdown
      setUserData([]);
    };

    window.addEventListener("scroll", handleScroll, true);

    return () => {
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as Node;

      if (
        dropdownRef.current?.contains(target) ||
        inputRef.current?.contains(target)
      ) {
        return; // click inside → do nothing
      }

      setUserData([]); // click outside → close dropdown
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelectUser = (user: UserOptiopn) => {
    setSelectedUser(user);
    setUserSearchQuery(user.usfUlNameRole ?? "");
    setUserData([]);
  };

  const handleSelectExam = (exam: any) => {
    if (!exam) return;

    setSelectedAppointment(exam.value);
  };

  const handleSelectRate = (rate: any) => {
    if (!rate) return;

    setRateType(rate.value);
  };

  const handleSelectCurrency = (currency: any) => {
    setSelectedCurrency(currency.value);
  };

  const handleCreateLineItems = () => {
    resetEditRow();
    setShowAddRow(true);
  };

  const validateLineItems = () => {
    const errors = [];

    if (!selectedUser) {
      errors.push("Please select a user.");
    }

    if (!selectedAppointment) {
      errors.push("Please select the Appointment Date & Time.");
    }

    if (!rateType) {
      errors.push("Please select the rate type.");
    }

    if (!selectedCurrency) {
      errors.push("Please select the currency type.");
    }

    if (!totalPages && !totalLines) {
      errors.push("Please enter atleast No. of Pages or No. of Lines");
    }

    if (!rate) {
      errors.push("Please enter a rate");
    }

    if (errors?.length > 0) {
      setSnackbarMessage(errors.join("\n"));
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };

  const onSaveLineItem = async () => {
    if (!validateLineItems()) return;
    try {
      const addPayload = {
        caseInfoId: caseInfoID,
        userId: selectedUser.userId,
        subjectQMEScheduleID: Number(selectedAppointment) || null,
        customRateType: rateType,
        customNoOfPages: totalPages,
        customNoOfLines: totalLines,
        customRate: rate,
        comments: "",
        effectiveChargeDate: effectiveDateFrom
          ? formatDateTime(effectiveDateFrom)
          : null,
        currencyType: selectedCurrency,
      };

      const response = await addLineItems(addPayload);

      if (response?.isSuccess) {
        resetAddRow();
        setSnackbarMessage("Line Items have been added successfully.");
        setError("success");
        setSnackbarOpen(true);
        await getLineItemsData();
        onAddSuccess?.();
      }
    } catch (error) {
      console.error("Error adding data :", error);
    }
  };

  const handleEditRow = (row: any) => {
    resetAddRow();

    setSelectedUser({
      userId: row.userId ?? null,
      usfUlNameRole: row.billingForUserFullName,
    });
    setEditingRowId(row.lineItemPk);
    setLineItemType(row.lineItemType);
    setSelectedAppointment(row.subjectQMEScheduleID);
    setRateType(row.billingRuleRateType);
    setTotalPages(row.totalNoOfPages);
    setTotalLines(row.totalNoOfLines);
    setCurrencySymbol(row.currencySymbol);
    setIsActive(row.isActive === 1);
    const rateAmount =
      typeof row.billingRuleRate === "string"
        ? row.billingRuleRate.replace(/[^0-9.]/g, "")
        : String(row.billingRuleRate ?? "");

    const billingAmount =
      typeof row.totalAmount === "string"
        ? row.totalAmount.replace(/[^0-9.]/g, "")
        : String(row.totalAmount ?? "");

    setSelectedCurrency(row.currencySymbol == "₹" ? "INR" : "USD");
    setRate(rateAmount);
    setAmount(billingAmount);

    setEffectiveDateFrom(row.effectiveChargeDate);
  };

  useEffect(() => {
    if (selectedUser?.userId) {
      setUserSearchQuery(selectedUser.usfUlNameRole);

      // also preload dropdown list with selected item
      setUserData([selectedUser]);
    }
  }, [selectedUser]);

  const onUpdateLineItem = async () => {
    if (!validateLineItems()) return;
    try {
      const updateCustomPayload = {
        invoiceCustomLineItemId: editingRowId,
        userId: selectedUser.userId,
        subjectQMEScheduleID: Number(selectedAppointment) || null,
        customRateType: rateType,
        customNoOfPages: totalPages,
        customNoOfLines: totalLines,
        customRate: rate,
        comments: "",
        effectiveChargeDate: effectiveDateFrom
          ? formatDateTime(effectiveDateFrom)
          : null,
        isActive: isActive == true ? 1 : 0,
        currencyType: selectedCurrency,
      };

      const updateLineItemPayload = {
        invoiceLineItemId: editingRowId,
        billingRuleRateType: rateType,
        billingRuleRate: rate,
        totalNoOfPages: totalPages,
        totalNoOfLines: totalLines,
        isActive: isActive == true ? 1 : 0,
      };

      let response =
        lineItemType == "CustomLineItem"
          ? await updateCustomLineItems(updateCustomPayload)
          : await updateAutomatedLineItems(updateLineItemPayload);
      if (response?.isSuccess) {
        resetEditRow();
        setSnackbarMessage("Line Items have been updated successfully");
        setError("success");
        setSnackbarOpen(true);
        await getLineItemsData();
        onAddSuccess?.();
      } else {
        setSnackbarMessage(response?.message);
        setError("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Error adding standard charges:", error);
    }
  };

  const handleDeleteRow = (row: any, isActiveValue: boolean) => {
    setActiveState(isActiveValue);
    // setDeletingRowId(row.lineItemPk);

    resetEditRow();
    setEditingRowId(row.lineItemPk);
    setSelectedUser({
      userId: row.userId ?? null,
      usfUlNameRole: row.billingForUserFullName,
    });
    setEditingRowId(row.lineItemPk);
    setLineItemType(row.lineItemType);
    setSelectedAppointment(row.subjectQMEScheduleID);
    setRateType(row.billingRuleRateType);
    setTotalPages(row.totalNoOfPages);
    setTotalLines(row.totalNoOfLines);
    setCurrencySymbol(row.currencySymbol);
    setIsActive(row.isActive === 1);
    const rateAmount =
      typeof row.billingRuleRate === "string"
        ? row.billingRuleRate.replace(/[^0-9.]/g, "")
        : String(row.billingRuleRate ?? "");

    const billingAmount =
      typeof row.totalAmount === "string"
        ? row.totalAmount.replace(/[^0-9.]/g, "")
        : String(row.totalAmount ?? "");

    setSelectedCurrency(row.currencySymbol == "₹" ? "INR" : "USD");
    setRate(rateAmount);
    setAmount(billingAmount);

    setEffectiveDateFrom(row.effectiveChargeDate);
    setShowDeleteModal(true);
  };

  const handleConfirmDeleteRow = async () => {
    try {
      const updateCustomPayload = {
        invoiceCustomLineItemId: editingRowId,
        userId: selectedUser.userId,
        subjectQMEScheduleID: Number(selectedAppointment) || null,
        customRateType: rateType,
        customNoOfPages: totalPages,
        customNoOfLines: totalLines,
        customRate: rate,
        comments: "",
        effectiveChargeDate: effectiveDateFrom
          ? formatDateTime(effectiveDateFrom)
          : null,
        isActive: activeState == true ? 1 : 0,
        currencyType: selectedCurrency,
      };

      const updateLineItemPayload = {
        invoiceLineItemId: editingRowId,
        billingRuleRateType: rateType,
        billingRuleRate: rate,
        totalNoOfPages: totalPages,
        totalNoOfLines: totalLines,
        isActive: activeState == true ? 1 : 0,
      };

      let response =
        lineItemType == "CustomLineItem"
          ? await updateCustomLineItems(updateCustomPayload)
          : await updateAutomatedLineItems(updateLineItemPayload);
      if (response?.isSuccess) {
        resetEditRow();
        setSnackbarMessage("Line Items have been updated successfully");
        setError("success");
        setSnackbarOpen(true);
        setShowDeleteModal(false);
        await getLineItemsData();
        onAddSuccess?.();
      } else {
        setSnackbarMessage(response?.message);
        setError("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Error updating", error);
    }
  };

  const handleCloseDeleteModal = () => {
    setEditingRowId(null);
    setShowDeleteModal(false);
  };

  const resetEditRow = () => {
    setEditingRowId(null);
    setLineItemType("");
    setUserSearchQuery("");
    setSelectedUser(null);
    setUserData([]);
    setDropdownStyle(null);
    setSelectedAppointment(null);
    setRateType(null);
    setTotalPages("");
    setTotalLines("");
    setRate("");
    setAmount("");
    setSelectedCurrency("USD");
    setCurrencySymbol("");
    setIsActive(true);
    setEffectiveDateFrom(new Date());
  };

  const resetAddRow = () => {
    setShowAddRow(false);
    setUserSearchQuery("");
    setSelectedUser(null);
    setUserData([]);
    setDropdownStyle(null);
    setSelectedAppointment(null);
    setRateType(null);
    setTotalPages("");
    setTotalLines("");
    setRate("");
    setAmount("");
    setEffectiveDateFrom(new Date());
    setSelectedCurrency("USD");
  };

  const tableContainerRef = useRef<HTMLDivElement>(null);

  const openCommentsModal = (row: any) => {
    setOpenModal(true);
    setEditingRowId(row.lineItemPk);
  };

  const closeCommentsModal = () => {
    setOpenModal(false);
    setEditingRowId(null);
  };

  useEffect(() => {
    if (showAddRow && tableContainerRef.current) {
      tableContainerRef.current.scrollTo({
        top: tableContainerRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [showAddRow]);

  const disabledAction =
    invoiceStatus == INVOICE_STATUS.INVOICED ||
    invoiceStatus == INVOICE_STATUS.CANCELLED ||
    invoiceStatus == INVOICE_STATUS.GENERATED;

  const handleNotesView = async (invoice: any, e: React.MouseEvent) => {
    setModalTitle("Notes");

    let notesDetails = [];

    if (invoice?.subjectQMEScheduleID) {
      notesDetails = await getInvoiceCaseNotes(
        invoice.subjectQMEScheduleID,
        invoice.lineItemPk,
      );

      setModalNotesData(
        notesDetails?.[0]?.subjectQmeScheduleId ? notesDetails : [],
      );
    }

    const rect = (e.target as HTMLElement).getBoundingClientRect();
    const modalWidth = window.innerWidth * 0.5;
    const verticalOffset = 5;
    const horizontalOffset = 18;
    let position: { top: number; left?: number; right?: number };
    if (rect.left < window.innerWidth / 2) {
      position = {
        top: rect.bottom + verticalOffset,
        left: rect.left + horizontalOffset,
      };
    } else {
      position = {
        top: rect.bottom + verticalOffset,
        left: rect.right - modalWidth - horizontalOffset,
      };
    }

    setModalPos(position);
    setShowModal(true);
  };

  const modalProps = {
    mode: "table" as const,
    data: modalNotesData,
    headers: INVOICE_NOTES_INFO_HEADER,
  };

  return (
    <>
      <Snackbar
        open={snackbarOpen}
        message={snackbarMessage}
        onClose={() => setSnackbarOpen(false)}
        severity={error}
      />
      <div className="border-0 mb-2 sticky-table-wrapper acutransGrida">
        <div
          className="table-responsive border-0 mb-2 table-scroll-container  adjustInvoiceGri"
          ref={tableContainerRef}
        >
          <Table className="mb-0 sticky-table">
            <thead>
              <tr>
                {headers.map((header) => (
                  // <th key={header.key} style={thStyle}>
                  <th
                    key={header.key}
                    style={{
                      border: "none",
                      padding: "8px",
                      backgroundColor: "#e0f7fa",
                      color: "#000",
                      cursor: header.sortable ? "pointer" : "default",
                      position: header.key === "actions" ? "sticky" : "sticky",
                      top: 0,
                      right: header.key === "actions" ? 0 : undefined,
                      zIndex: header.key === "actions" ? 5 : -90,

                      backgroundClip: "padding-box",

                      textAlign: ["actions", "totalQuantityPgLn"].includes(
                        header.key,
                      )
                        ? "center"
                        : "left",
                      ...header.style,
                    }}
                  >
                    <div
                      style={{
                        display: ["actions", "totalQuantityPgLn"].includes(
                          header.key,
                        )
                          ? "flex"
                          : "flex",

                        justifyContent: [
                          "actions",
                          "totalQuantityPgLn",
                        ].includes(header.key)
                          ? "space-evenly"
                          : "space-between",

                        alignItems: "center",
                      }}
                    >
                      <span>{header.label}</span>
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {lineItemData?.length > 0 &&
                lineItemData.map((row, index) => (
                  <tr
                    key={index}
                    style={{
                      backgroundColor: index % 2 === 1 ? "white" : "#f2f2f2",
                    }}
                  >
                    {headers.map((header) => {
                      const cellContent = row[header.key];
                      const isEditDisabled =
                        row.invoiceLineItemStatus === "Invoice Generated";
                      return (
                        <td
                          key={header.key}
                          style={{
                            padding: header.isNumeric
                              ? "8px 20px 8px 8px"
                              : "8px",
                            textAlign: header.isNumeric ? "center" : "left",
                            position:
                              header.key === "actions" ? "sticky" : "static",
                            right: 0,
                            backgroundColor: "#f2f2f2",
                            zIndex: 4,
                          }}
                        >
                          {header.key === "actions" ? (
                            editingRowId === row.lineItemPk ? (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  gap: "12px",
                                }}
                              >
                                <span
                                  className="material-symbols-outlined"
                                  style={{
                                    cursor: "pointer",
                                    color: "#0092d5",
                                  }}
                                  onClick={() => onUpdateLineItem()}
                                >
                                  save
                                </span>

                                <span
                                  className="material-symbols-outlined"
                                  style={{
                                    cursor: "pointer",
                                    color: "#dc3545",
                                  }}
                                  onClick={resetEditRow}
                                >
                                  close
                                </span>
                              </div>
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "left",
                                  gap: "8px",
                                  paddingLeft: "10px",
                                }}
                              >
                                <span
                                  className="material-symbols-outlined"
                                  style={{
                                    cursor: isEditDisabled
                                      ? "not-allowed"
                                      : "pointer",
                                    color: isEditDisabled ? "#ccc" : "#0092d5",
                                    opacity: isEditDisabled ? 0.6 : 1,
                                  }}
                                  onClick={
                                    !isEditDisabled
                                      ? () => handleEditRow(row)
                                      : undefined
                                  }
                                >
                                  edit
                                </span>

                                {row.isActive == 1 ? (
                                  !isEditDisabled ? (
                                    <OverlayTrigger
                                      placement="auto"
                                      trigger={["hover", "focus"]}
                                      delay={{ show: 200, hide: 100 }}
                                      overlay={
                                        <Tooltip id="inactive-tooltip">
                                          Inactive this line item
                                        </Tooltip>
                                      }
                                    >
                                      <span
                                        className="material-symbols-outlined"
                                        style={{
                                          cursor: "pointer",
                                          color: "#dc3545",
                                          opacity: 1,
                                        }}
                                        onClick={() =>
                                          handleDeleteRow(row, false)
                                        }
                                      >
                                        font_download
                                      </span>
                                    </OverlayTrigger>
                                  ) : (
                                    <span
                                      className="material-symbols-outlined"
                                      style={{
                                        cursor: "not-allowed",
                                        color: "#ccc",
                                        opacity: 0.6,
                                      }}
                                    >
                                      font_download
                                    </span>
                                  )
                                ) : !disabledAction ? (
                                  <OverlayTrigger
                                    placement="auto"
                                    trigger={["hover", "focus"]}
                                    delay={{ show: 200, hide: 100 }}
                                    overlay={
                                      <Tooltip id="inactive-tooltip">
                                        Activate this line item
                                      </Tooltip>
                                    }
                                  >
                                    <span
                                      className="material-symbols-outlined"
                                      style={{
                                        cursor: disabledAction
                                          ? "not-allowed"
                                          : "pointer",
                                        color: disabledAction
                                          ? "#ccc"
                                          : "#78dc35",
                                        opacity: disabledAction ? 0.6 : 1,
                                      }}
                                      onClick={
                                        !disabledAction
                                          ? () => handleDeleteRow(row, true)
                                          : undefined
                                      }
                                    >
                                      font_download
                                    </span>
                                  </OverlayTrigger>
                                ) : (
                                  <span
                                    className="material-symbols-outlined"
                                    style={{
                                      cursor: "not-allowed",
                                      color: "#ccc",
                                      opacity: 0.6,
                                    }}
                                  >
                                    font_download
                                  </span>
                                )}
                                <span
                                  className="material-symbols-outlined"
                                  style={{
                                    cursor: "pointer",
                                    color: "#0092d5",
                                  }}
                                  onClick={(e) => handleNotesView(row, e)}
                                >
                                  chat_bubble
                                </span>
                              </div>
                            )
                          ) : editingRowId === row.lineItemPk ? (
                            header.key === "billingForUserFullName" &&
                            row.lineItemType == "CustomLineItem" ? (
                              <td style={{ position: "relative" }}>
                                <input
                                  ref={inputRef}
                                  type="text"
                                  className="form-control form-control-sm"
                                  placeholder="Search user..."
                                  value={userSearchQuery}
                                  onChange={handleSearchUser}
                                  autoComplete="off"
                                />

                                {userData.length > 0 && dropdownStyle && (
                                  <ul
                                    ref={dropdownRef}
                                    className="list-group customInvoiceDroppdown"
                                    style={dropdownStyle}
                                  >
                                    {userData.map((user) => (
                                      <li
                                        key={user.userId}
                                        className={`list-group-item ${
                                          selectedUser?.userId === user.userId
                                            ? "active"
                                            : ""
                                        }`}
                                        onMouseDown={(e) => {
                                          e.preventDefault(); // critical
                                          handleSelectUser(user);
                                        }}
                                        style={{
                                          cursor: "pointer",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "8px",
                                          width: "550px  !important",
                                        }}
                                      >
                                        <input
                                          type="radio"
                                          name="userSelectEdit"
                                          checked={
                                            selectedUser?.userId === user.userId
                                          }
                                          readOnly
                                          style={{ cursor: "pointer" }}
                                        />

                                        <span>{user.usfUlNameRole}</span>
                                      </li>
                                    ))}
                                  </ul>
                                )}
                              </td>
                            ) : // header.key === "appointmentInfo" &&
                            //   row.lineItemType == "CustomLineItem" ? (
                            //   <TableSingleSelectDropdown
                            //     value={selectedAppointment}
                            //     options={appointmentOptions}
                            //     placeholder="Search Appointment Date & Time..."
                            //     onChange={(exam) => handleSelectExam(exam)}
                            //
                            //   />
                            // ) :
                            header.key === "rateType" ? (
                              <TableSingleSelectDropdown
                                value={rateType}
                                options={rateTypeOptions}
                                placeholder="Search rate type..."
                                onChange={(rate) => handleSelectRate(rate)}
                              />
                            ) : header.key === "totalNoOfPages" ? (
                              <input
                                type="text"
                                className="form-control form-control-sm text-end"
                                value={totalPages}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (/^\d*$/.test(value)) setTotalPages(value);
                                }}
                              />
                            ) : header.key === "totalNoOfLines" ? (
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                value={totalLines}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (/^\d*$/.test(value)) setTotalLines(value);
                                }}
                              />
                            ) : header.key === "generatedBy" ? (
                              <NormalDatePicker
                                value={effectiveDateFrom}
                                onChange={(date) => setEffectiveDateFrom(date)}
                                maxDate={new Date()}
                              />
                            ) : header.key === "billingRuleRate" ? (
                              <CurrencyRateInput
                                currencyValue={selectedCurrency}
                                currencyOptions={currencyOptions}
                                rate={rate}
                                onCurrencyChange={handleSelectCurrency}
                                onRateChange={setRate}
                                currencyDisabled={true}
                              />
                            ) : header.key === "isActive" &&
                              editingRowId === row.lineItemPk ? (
                              <div className="d-flex  gap-2">
                                {/* <Form.Check
                                  type="switch"
                                  id={`active-switch-${row.lineItemPk}`}
                                  checked={isActive}
                                  onChange={(e) =>
                                    setIsActive(e.target.checked)
                                  }
                                /> */}

                                <span
                                  style={{
                                    color: isActive ? "#0092d5" : "#4d4c4c",
                                    fontWeight: 500,
                                  }}
                                >
                                  {isActive ? "Active" : "In Active"}
                                </span>
                              </div>
                            ) : (
                              cellContent
                            )
                          ) : header.key === "isActive" ? (
                            <div className="d-flex  gap-2">
                              {/* <Form.Check
                                type="switch"
                                id={`active-switch-${row.lineItemPk}`}
                                checked={row.isActive === 1}
                                disabled
                              /> */}

                              <span
                                style={{
                                  color: row.isActive ? "#0092d5" : "#4d4c4c",
                                  fontWeight: 500,
                                }}
                              >
                                {row.isActive === 1 ? "Active" : "In Active"}
                              </span>
                            </div>
                          ) : header.key === "totalAmount" ? (
                            <div
                              style={{
                                alignItems: "end",
                                gap: "6px",
                              }}
                            >
                              {row.lineItemType === "CustomLineItem" && (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip
                                      id={`tooltip-custom-charge-${row.id}`}
                                    >
                                      Custom Charge
                                    </Tooltip>
                                  }
                                >
                                  <span className="customChargeBadge" />
                                </OverlayTrigger>
                              )}
                              <span className="amountTxt">
                                {row.totalAmount}
                              </span>
                            </div>
                          ) : (
                            <OverlayTrigger
                              placement="auto"
                              delay={{ show: 200, hide: 10 }}
                              overlay={
                                cellContent && cellContent?.length > 10 ? (
                                  <Tooltip
                                    id={`tooltip-${header.key}-${row.id}`}
                                    style={{ backgroundColor: "#b3e0ff" }}
                                  >
                                    {cellContent}
                                  </Tooltip>
                                ) : (
                                  <></>
                                )
                              }
                            >
                              <span
                                // className= 'd-inline-block text-truncate'
                                // className={`d-inline-block case-type-2line`}
                                style={{
                                  // maxWidth: "90%",
                                  cursor: "pointer",
                                }}
                              >
                                {cellContent}
                              </span>
                            </OverlayTrigger>
                          )}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              {showAddRow && (
                <tr style={{ backgroundColor: "#fffef1" }}>
                  <td style={{ position: "relative" }}>
                    <input
                      ref={inputRef}
                      type="text"
                      className="form-control form-control-sm "
                      placeholder="Search user..."
                      value={userSearchQuery}
                      onChange={handleSearchUser}
                      autoComplete="off"
                    />

                    {userData.length > 0 && dropdownStyle && (
                      <ul
                        className="list-group customInvoiceDroppdown"
                        style={dropdownStyle}
                        ref={dropdownRef}
                      >
                        {userData.map((user) => (
                          <li
                            key={user.userId}
                            className="list-group-item"
                            onMouseDown={(e) => {
                              e.preventDefault(); // VERY important
                              handleSelectUser(user);
                            }}
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              width: "550px !important",
                            }}
                          >
                            <input
                              type="radio"
                              name="userSelect"
                              checked={selectedUser?.userId === user.userId}
                              readOnly
                              style={{ cursor: "pointer" }}
                            />

                            <span>{user.usfUlNameRole}</span>
                          </li>
                        ))}
                      </ul>
                    )}
                  </td>
                  <td>
                    <TableSingleSelectDropdown
                      value={selectedAppointment}
                      options={appointmentOptions}
                      placeholder="Search Appointment Date & Time..."
                      onChange={(exam) => handleSelectExam(exam)}
                    />
                  </td>
                  <td>
                    <TableSingleSelectDropdown
                      value={rateType}
                      options={rateTypeOptions}
                      placeholder="Search rate type..."
                      onChange={(rate) => handleSelectRate(rate)}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      className="form-control form-control-sm text-end"
                      value={totalPages}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                          setTotalPages(value);
                        }
                      }}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      className="form-control form-control-sm text-end"
                      value={totalLines}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                          setTotalLines(value);
                        }
                      }}
                    />
                  </td>

                  <td>
                    <CurrencyRateInput
                      currencyValue={selectedCurrency}
                      currencyOptions={currencyOptions}
                      rate={rate}
                      onCurrencyChange={handleSelectCurrency}
                      onRateChange={setRate}
                    />
                  </td>
                  {/* Invoice Status */}
                  <td>Ready To Bill</td>
                  <td>
                    {/* <div className="input-group input-group-sm">
                    <span className="input-group-text">$</span>

                    <input
                      type="text"
                      className="form-control"
                      value={amount}
                      onChange={(e) => {
                        const value = e.target.value;
                        const regex = /^\d+(\.\d{0,2})?$/;

                        if (value === "" || regex.test(value)) {
                          setAmount(value);
                        }
                      }}
                      readOnly
                    />
                  </div> */}
                    -
                  </td>
                  {/* Is Active */}
                  <td>
                    <div className="d-flex  gap-2">
                      <Form.Check
                        type="switch"
                        id={`active-switch-view-`}
                        checked={true}
                        disabled
                      />

                      <span>{"Active"}</span>
                    </div>
                  </td>
                  {/* Generated On | By */}
                  <td>
                    <NormalDatePicker
                      value={effectiveDateFrom}
                      onChange={(date) => setEffectiveDateFrom(date)}
                      maxDate={new Date()}
                    />
                  </td>

                  <td
                    style={{
                      textAlign: "center",
                      position: "sticky",
                      right: 0,
                      backgroundColor: "#f2f2f2",
                      zIndex: 4,
                    }}
                  >
                    <span
                      className="material-symbols-outlined me-2"
                      style={{ cursor: "pointer", color: "#0092d5" }}
                      onClick={onSaveLineItem}
                    >
                      save
                    </span>

                    <span
                      className="material-symbols-outlined"
                      style={{ cursor: "pointer", color: "#dc3545" }}
                      onClick={resetAddRow}
                    >
                      close
                    </span>
                  </td>
                </tr>
              )}
            </tbody>
            <tfoot>
              {!showAddRow && (
                <tr>
                  <td
                    colSpan={headers.length}
                    style={{
                      textAlign: "center",
                      padding: "12px",
                      backgroundColor: "#f4f7fe",
                      position: "sticky",
                      bottom: "-2px",
                      zIndex: 20,
                    }}
                  >
                    <button
                      onClick={handleCreateLineItems}
                      style={{
                        background: "none",
                        border: "none",
                        color: "#0092d5",
                        cursor: "pointer",
                      }}
                      disabled={disabledAction}
                    >
                      <span className="material-icons me-2">add</span>
                      Create Invoice Line Items
                    </button>
                  </td>
                </tr>
              )}
            </tfoot>
          </Table>

          <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
            <Modal.Body className="fw-bold text-left modelheading ">
              <div>
                Are you sure you want to {activeState ? "activate" : "delete"}{" "}
                this line item?
              </div>
            </Modal.Body>
            <Modal.Footer className="border-top d-flex justify-content-end">
              <Button
                variant="outline-info"
                className="d-flex align-items-end"
                onClick={handleCloseDeleteModal}
              >
                <span className="material-icons mr-2">close</span> Cancel
              </Button>
              <Button
                onClick={handleConfirmDeleteRow}
                variant="primary"
                className="ms-3 d-flex align-items-center"
              >
                <span className="material-icons mx-1">check</span> Confirm
              </Button>
            </Modal.Footer>
          </Modal>
          {openComments && (
            <InvoiceCommentsDrawer
              title="View Comments"
              open={openComments}
              onClose={closeCommentsModal}
              placement="end"
              width={"70%"}
              height={"auto"}
              top={"105px"}
            >
              <ViewComments
                lineItemID={editingRowId}
                onClose={closeCommentsModal}
              />
            </InvoiceCommentsDrawer>
          )}
        </div>
      </div>
      <FloatingTableModal
        show={showModal}
        onClose={() => setShowModal(false)}
        title={modalTitle}
        position={modalPos}
        {...modalProps}
      />
    </>
  );
};

export default InvoiceLineItemEditTableData;
